import { render, staticRenderFns } from "./usp-with-icon.vue?vue&type=template&id=6042ab36&"
import script from "./usp-with-icon.vue?vue&type=script&lang=js&"
export * from "./usp-with-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports